import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  ReactNode,
} from "react";
import type { PaywallOptions } from "./Paywall";

type PaywallContextValue = {
  isOpen: boolean;
  options?: PaywallOptions | null;
  openPaywall: (opts?: PaywallOptions) => void;
  closePaywall: () => void;
};

const PaywallContext = createContext<PaywallContextValue | undefined>(
  undefined
);

export const PaywallProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState<PaywallOptions | null>(null);

  const openPaywall = (opts?: PaywallOptions) => {
    setOptions(opts ?? null);
    setIsOpen(true);
  };

  const closePaywall = () => {
    setIsOpen(false);
    setOptions(null);
  };

  const value = useMemo(
    () => ({ isOpen, options, openPaywall, closePaywall }),
    [isOpen, options]
  );

  return (
    <PaywallContext.Provider value={value}>{children}</PaywallContext.Provider>
  );
};

export function usePaywall() {
  const ctx = useContext(PaywallContext);
  if (!ctx) {
    throw new Error("usePaywall must be used within a PaywallProvider");
  }
  return ctx;
}
